var isNaN = function isNaN(value) {
  return value !== value;
};

export default isNaN;